/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {  
  constructor() {
  super();
  this.section = this.closest('.js-product');
  this.productForm = this.section.querySelector('.js-product-form');
  this.optionSelectors = Array.from(this.querySelectorAll('.option-selector:not(.option-selector--custom)'));
  this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
  this.data = this.getVariantData();

  console.log('VariantPicker initialized', {
    optionSelectorsCount: this.optionSelectors.length,
    selectorOptions: this.optionSelectors.map(s => s.dataset.option),
    formId: this.productForm ? this.productForm.querySelector('[name="id"]').value : 'none'
  });

  // Clear any default checked inputs
  this.optionSelectors.forEach((selector) => {
    const checkedInput = selector.querySelector('input.js-option:checked');
    if (checkedInput) {
      checkedInput.checked = false;
    }
  });

  // Initialize with no variant selected
  this.selectedOptions = Array(this.optionSelectors.length).fill(null);
  this.variant = null;

  // Initial UI setup for unselected state
  this.updateAvailability();
  this.addEventListener('change', this.handleVariantChange.bind(this));
  this.addEventListener('on:thumbnail:select', this.handleThumbnailSelect.bind(this));
  this.setupHoverEvents();

  // Thumbnail click handlers
  const thumbnails = document.querySelectorAll('.slider__item[data-media-id]');
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const mediaId = thumbnail.dataset.mediaId;
      console.log('Thumbnail clicked', { mediaId });
      const event = new CustomEvent('on:thumbnail:select', {
        bubbles: true,
        detail: { mediaId: parseInt(mediaId, 10) }
      });
      this.dispatchEvent(event);
    });
  });

  this.setAttribute('loaded', '');
}


setupHoverEvents() {
  const colorSelector = Array.from(this.optionSelectors).find(
    (selector) => selector.dataset.selectorType === 'listed' && selector.dataset.option === 'Color'
  );
  if (colorSelector) {
    console.log('Setting up hover events for Color selector', {
      inputs: colorSelector.querySelectorAll('input.js-option').length,
      inputValues: [...colorSelector.querySelectorAll('input.js-option')].map(i => i.value)
    });
    const inputs = colorSelector.querySelectorAll('input.js-option');

    inputs.forEach((input, index) => {
      const label = input.nextElementSibling;
      label.removeEventListener('mouseenter', this.handleHover);
      label.removeEventListener('mouseleave', this.handleMouseOut);

      label.addEventListener('mouseenter', () => {
  // Keep tooltip + label hover feedback (optional visual)
  if (label._tooltip) {
    label._tooltip.remove();
    label._tooltip = null;
  }

  const tooltipText = label.dataset.tooltip || input.value;
  const tooltip = document.createElement('div');
  tooltip.className = 'swatch-tooltip';
  tooltip.textContent = tooltipText;
  tooltip.style.position = 'absolute';
  tooltip.style.backgroundColor = '#6b7280';
  tooltip.style.color = '#ffffff';
  tooltip.style.padding = '4px 8px';
  tooltip.style.borderRadius = '4px';
  tooltip.style.fontSize = '12px';
  tooltip.style.zIndex = '1000';
  tooltip.style.whiteSpace = 'nowrap';
  tooltip.style.pointerEvents = 'none';

  try {
    document.body.appendChild(tooltip);
  } catch (e) {}

  const labelRect = label.getBoundingClientRect();
  if (labelRect.width === 0 || labelRect.height === 0) {
    const selectorRect = colorSelector.getBoundingClientRect();
    tooltip.style.top = `${window.scrollY + selectorRect.bottom + 6}px`;
    tooltip.style.left = `${window.scrollX + selectorRect.left}px`;
  } else {
    tooltip.style.top = `${window.scrollY + labelRect.bottom + 6}px`;
    tooltip.style.left = `${window.scrollX + labelRect.left + (labelRect.width - tooltip.offsetWidth) / 2}px`;
  }
  label._tooltip = tooltip;

  VariantPicker.updateLabelText({ target: input });

  // ────────────────────────────────────────────────
  // NO preview, NO dispatch, NO state change on hover
  // This completely stops the autoscrolling trigger chain
  // ────────────────────────────────────────────────
  console.log('Hover preview disabled - no dispatch');
});
label.addEventListener('mouseleave', () => {
  if (label._tooltip) {
    label._tooltip.remove();
    label._tooltip = null;
  }

  const checkedInput = colorSelector.querySelector('input.js-option:checked');
  if (checkedInput) {
    VariantPicker.updateLabelText({ target: checkedInput });
  } else {
    const colorText = colorSelector.querySelector('.js-color-text');
    if (colorText) colorText.textContent = '';
  }

  // NO dispatch on mouseleave either
  console.log('Mouseleave preview disabled - no dispatch');
});



    });
  } else {
    console.log('No Color selector found for hover events');
  }
}


/** Removed Variant Image Selection on Hover - Ivan 
setupHoverEvents() {
      const colorSelector = Array.from(this.optionSelectors).find(
        (selector) => selector.dataset.selectorType === 'listed' && selector.dataset.option === 'Color'
      );
      if (colorSelector) {
        console.log('Setting up hover events for Color selector', {
          inputs: colorSelector.querySelectorAll('input.js-option').length,
          inputValues: [...colorSelector.querySelectorAll('input.js-option')].map(i => i.value)
        });
        const inputs = colorSelector.querySelectorAll('input.js-option');

        inputs.forEach((input, index) => {
          const label = input.nextElementSibling;
          // Remove existing listeners (safety precaution)
          label.removeEventListener('mouseenter', this.handleHover);
          label.removeEventListener('mouseleave', this.handleMouseOut);

          label.addEventListener('mouseenter', () => {
            console.log(`Hover event on input ${index + 1}`, {
              value: input.value,
              description: label.dataset.description,
              tooltip: label.dataset.tooltip,
              isUnavailable: input.classList.contains('is-unavailable')
            });

            // Store original state
            const originalOptions = [...this.selectedOptions];
            const originalVariant = this.variant;

            // Remove any existing tooltip
            if (label._tooltip) {
              console.log('Removing existing tooltip for', input.value);
              label._tooltip.remove();
              label._tooltip = null;
            }

            // Create tooltip
            const tooltipText = label.dataset.tooltip || input.value;
            const tooltip = document.createElement('div');
            tooltip.className = 'swatch-tooltip';
            tooltip.textContent = tooltipText;
            tooltip.style.position = 'absolute';
            tooltip.style.backgroundColor = '#6b7280';
            tooltip.style.color = '#ffffff';
            tooltip.style.padding = '4px 8px';
            tooltip.style.borderRadius = '4px';
            tooltip.style.fontSize = '12px';
            tooltip.style.zIndex = '1000';
            tooltip.style.whiteSpace = 'nowrap';
            tooltip.style.pointerEvents = 'none';

            try {
              document.body.appendChild(tooltip);
              console.log('Tooltip appended for', input.value, { text: tooltipText });
            } catch (e) {
              console.error('Failed to append tooltip', e);
              return;
            }

            const labelRect = label.getBoundingClientRect();
            if (labelRect.width === 0 || labelRect.height === 0) {
              console.warn('Invalid label dimensions', labelRect);
              const selectorRect = colorSelector.getBoundingClientRect();
              tooltip.style.top = `${window.scrollY + selectorRect.bottom + 6}px`; // Adjusted for arrow
              tooltip.style.left = `${window.scrollX + selectorRect.left}px`;
            } else {
              tooltip.style.top = `${window.scrollY + labelRect.bottom + 6}px`; // Adjusted for arrow
              tooltip.style.left = `${window.scrollX + labelRect.left + (labelRect.width - tooltip.offsetWidth) / 2}px`;
            }
            label._tooltip = tooltip;

            // Update label text without selecting variant
            VariantPicker.updateLabelText({ target: input });

            // Update product image without selecting variant
            const colorIndex = Array.from(this.optionSelectors).indexOf(colorSelector);
            this.selectedOptions[colorIndex] = input.value;
            this.variant = this.getSelectedVariant();

            console.log('Hover state for image update', {
              selectedOptions: this.selectedOptions,
              variantId: this.variant ? this.variant.id : 'none',
              formId: this.productForm ? this.productForm.querySelector('[name="id"]').value : 'none'
            });

            if (this.variant) {
              console.log('Dispatching on:variant:change for hover', {
                variantId: this.variant.id,
                hasFeaturedMedia: !!this.variant.featured_media
              });
              this.dispatchEvent(new CustomEvent('on:variant:change', {
                bubbles: true,
                detail: {
                  form: this.productForm,
                  variant: { ...this.variant }, // Clone to avoid side effects
                  allVariants: this.data.variants,
                  selectedOptions: this.selectedOptions
                }
              }));
            }

            // Restore original state to prevent selection
            this.selectedOptions = originalOptions;
            this.variant = originalVariant;

            console.log('Restored state after hover', {
              selectedOptions: this.selectedOptions,
              variantId: this.variant ? this.variant.id : 'none',
              formId: this.productForm ? this.productForm.querySelector('[name="id"]').value : 'none'
            });
          });

          label.addEventListener('mouseleave', () => {
            console.log('Mouseleave event for', input.value);

            // Remove tooltip immediately
            if (label._tooltip) {
              console.log('Removing tooltip on mouseleave for', input.value);
              label._tooltip.remove();
              label._tooltip = null;
            }

            // Restore label text and product image
            const checkedInput = colorSelector.querySelector('input.js-option:checked');
            if (checkedInput) {
              console.log('Restoring label text for', checkedInput.value);
              VariantPicker.updateLabelText({ target: checkedInput });
            } else {
              // Clear label text if no variant is selected
              const colorText = colorSelector.querySelector('.js-color-text');
              if (colorText) {
                console.log('Clearing label text (no variant selected)');
                colorText.textContent = '';
              }
            }
            // Restore product image to selected variant (or none)
            console.log('Dispatching on:variant:change for mouseleave', {
              variantId: this.variant ? this.variant.id : 'none',
              hasFeaturedMedia: this.variant ? !!this.variant.featured_media : false
            });
            this.dispatchEvent(new CustomEvent('on:variant:change', {
              bubbles: true,
              detail: {
                form: this.productForm,
                variant: this.variant ? { ...this.variant } : null,
                allVariants: this.data.variants,
                selectedOptions: this.selectedOptions
              }
            }));
          });
        });
      } else {
        console.log('No Color selector found for hover events');
      }
    }

 */


/**
 * Handles thumbnail selection events from the carousel.
 * @param {CustomEvent} evt - Event object containing mediaId.
 */
handleThumbnailSelect(evt) {
  const { mediaId } = evt.detail;
  console.log('Thumbnail select event received', { mediaId });

  // Find variant associated with the media ID
  const variant = this.data.variants.find((v) => v.featured_media && v.featured_media.id === mediaId);
  if (!variant) {
    console.warn('No variant found for media ID', mediaId);
    return;
  }

  console.log('Found variant for thumbnail', { variantId: variant.id, title: variant.title });

  // Update selected options based on variant
  this.selectedOptions = [...variant.options];
  this.variant = variant;

  // Programmatically select the corresponding radio inputs or dropdown options
  this.optionSelectors.forEach((selector, index) => {
    const optionValue = variant.options[index];
    if (selector.dataset.selectorType === 'dropdown') {
      const optionEl = selector.querySelector(`.custom-select__option[data-value="${optionValue}"]`);
      if (optionEl) {
        console.log('Selecting dropdown option', { value: optionValue });
        optionEl.click(); // Trigger click to update custom-select
      }
    } else {
      const input = selector.querySelector(`input[value="${optionValue}"]`);
      if (input) {
        console.log('Selecting radio input', { value: optionValue });
        input.checked = true;
      }
    }
  });

  // Update UI elements
  this.updateVariantInput();
  this.updateAddToCartButton();
  this.updateAvailability();
  this.updatePrice();
  this.updateBackorderText();
  this.updatePickupAvailability();
  this.updateSku();
  this.updateBarcode();
  this.updateUrl({ type: 'change' });

  // Update label legend
  if (!this.optionSelectors || !Array.isArray(this.optionSelectors)) {
    console.error('optionSelectors is not an array', { optionSelectors: this.optionSelectors });
    return;
  }

  const colorSelector = this.optionSelectors.find(
    (selector) => selector.dataset.option && ['color', 'colour'].includes(selector.dataset.option.toLowerCase())
  );
  if (colorSelector) {
    const colorIndex = this.optionSelectors.indexOf(colorSelector);
    const colorValue = variant.options[colorIndex];
    if (colorSelector.dataset.selectorType === 'dropdown') {
      const optionEl = colorSelector.querySelector(`.custom-select__option[data-value="${colorValue}"]`);
      if (optionEl) {
        const description = optionEl.dataset.description || colorValue;
        console.log('Updating label text for dropdown', { colorValue, colorIndex, description });
        const colorText = colorSelector.querySelector('.js-color-text');
        if (colorText) {
          colorText.textContent = description && description !== '[Metafield missing]' ? description : colorValue;
        } else {
          console.warn('No .js-color-text found in dropdown selector');
        }
      } else {
        console.warn('No dropdown option found for color value', { colorValue, colorIndex });
      }
    } else {
      const input = colorSelector.querySelector(`input[value="${colorValue}"]`);
      if (input) {
        console.log('Updating label text for thumbnail select', {
          colorValue,
          colorIndex,
          description: input.nextElementSibling ? input.nextElementSibling.dataset.description : 'none'
        });
        VariantPicker.updateLabelText({ target: input });
      } else {
        console.warn('No input found for color value', { colorValue, colorIndex });
      }
    }
  } else {
    console.warn('No Color selector found for legend update', {
      selectors: this.optionSelectors.map(s => s.dataset.option)
    });
  }

  // Dispatch variant change event to update media gallery
  console.log('Dispatching on:variant:change for thumbnail select', {
    variantId: variant.id,
    hasFeaturedMedia: !!variant.featured_media
  });
  this.dispatchEvent(new CustomEvent('on:variant:change', {
    bubbles: true,
    detail: {
      form: this.productForm,
      variant: { ...variant },
      allVariants: this.data.variants,
      selectedOptions: this.selectedOptions
    }
  }));
}
    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      console.log('handleVariantChange triggered', {
        eventType: evt.type,
        targetValue: evt.target.value,
        formId: this.productForm ? this.productForm.querySelector('[name="id"]').value : 'none'
      });

      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      console.log('Updated state', {
        selectedOptions: this.selectedOptions,
        variantId: this.variant ? this.variant.id : 'none'
      });

      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);

      console.log('Dispatching on:variant:change', {
        variantId: this.variant ? this.variant.id : 'none',
        hasFeaturedMedia: this.variant ? !!this.variant.featured_media : false
      });
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const text = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : (this.variant ? theme.strings.noStock : theme.strings.noVariant);

      console.log('Updating add-to-cart button', {
        disabled: !variantAvailable,
        text
      });

      this.addBtn.disabled = !variantAvailable || !this.variant;
      this.addBtn.textContent = text;
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMode } = this.dataset;
      let currVariant = this.variant || { options: this.selectedOptions };

      console.log('Updating availability', {
        mode: availabilityMode,
        variantId: this.variant ? this.variant.id : 'none'
      });

      const updateOptionAvailability = (optionEl, exists, available) => {
        const el = optionEl;
        const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);
        el.classList.toggle('is-nonexistent', !exists);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');
          if (em) {
            em.hidden = available;
          }
          if (!available) {
            if (em) {
              em.textContent = unavailableText;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
            }
          }
        } else if (!available) {
      //    el.nextElementSibling.title = unavailableText;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      };

      if (availabilityMode === 'selection') {
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          updateOptionAvailability(optionEl, false, false);
        });

        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;
            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });
            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });
              if (optionEl) {
                updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matchesSelectedAbove = selectorIndex < 1;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matchesSelectedAbove = true;
                }
              }
              if (v.options[selectorIndex] === optionValue && matchesSelectedAbove) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];
        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;
          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      console.log('Updating backorder', { hidden: hideBackorder });
      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) {
        console.warn('No .js-color-text element found in selector');
        return;
      }

      const label = evt.target.nextElementSibling;
      const description = label.dataset.description;
      let textContent;
      if (description && description !== '[Metafield missing]') {
        textContent = description;
      } else {
        const valueEl = label.querySelector('.js-value');
        textContent = valueEl ? valueEl.textContent : evt.target.value;
      }

      console.log('Updating label text', { text: textContent });
      colorText.textContent = textContent;
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        console.log('Updating pickup availability', { variantId: this.variant.id });
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        console.log('Clearing pickup availability');
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-price .price');
      if (!this.price) return;

      let variant = this.variant;
      if (this.preSelection) {
        variant = this.data.variants[0];
        for (let i = 1; i < this.data.variants.length; i += 1) {
          if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        }
      }

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || '';

        try {
          priceCurrentEl.classList.remove("wpd-processed");
          priceCurrentEl.setAttribute("data-wpd-variant-compare-at-price", variant.compare_at_price == null ? "" : variant.compare_at_price);
          priceCurrentEl.setAttribute("data-wpd-variant-price", variant.price);
          priceCurrentEl.setAttribute("data-wpd-variant-id", variant.id);
          priceCurrentEl.setAttribute("data-wpd-product-handle", window.wpdExtensionIsProductPage.handle);
        } catch (e) {
          console.error('Error updating price attributes', e);
        }

        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        console.log('Updating price', {
          current: this.data.formatted[variant.id].price,
          compareAt: this.data.formatted[variant.id].compareAtPrice,
          onSale: variant.compare_at_price > variant.price,
          soldOut: !variant.available && !this.preSelection
        });

        this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);
      } else {
        console.log('Clearing price (no variant selected)');
        const priceCurrentEl = this.price.querySelector('.price__current');
        priceCurrentEl.innerHTML = '';
        const priceWasEl = this.price.querySelector('.price__was');
        if (priceWasEl) priceWasEl.innerHTML = '';
        const unitPriceEl = this.price.querySelector('.unit-price');
        if (unitPriceEl) unitPriceEl.hidden = true;
        this.price.classList.remove('price--on-sale', 'price--sold-out');
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      console.log('Updating SKU', { sku: skuAvailable ? this.variant.sku : '' });
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      console.log('Updating barcode', { barcode: barcodeAvailable ? this.variant.barcode : '' });
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      console.log('Updating URL', { url });
      window.history.replaceState({}, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments fx-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('Updating variant input', { value: input.value });
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}